import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { AUTH_ROUTES } from '../../../lib/constants';
import { PasswordLinkExpiredPageCombinedProps } from './types';

const usePresenter = (props: PasswordLinkExpiredPageCombinedProps): PasswordLinkExpiredPageCombinedProps => {
  const { t } = useTranslation();
  const history = useHistory();

  const goToForgotPassword = () => {
    history.replace(AUTH_ROUTES.forgotPassword);
  };

  return {
    ...props,
    genericActionBlock: {
      button: {
        text: {
          value: t('password_link_expired.get_new_link_button'),
        },
        icon: {
          asset: 'ArrowRight',
        },
        onClick: goToForgotPassword,
      },
      textGroup: {
        topText: {
          value: t('password_link_expired.title'),
        },
        bottomText: {
          value: t('password_link_expired.description'),
        },
      },
    },
  };
};

export default usePresenter;
